import React from 'react';
import styles from '../UploadCard.module.scss';

export const UploadAnotherFile = ({ handleClick }: any) => {
    return (
        <div className={styles.width100}>
            <div className={styles.UploadAnother} onClick={handleClick}>
                <img src="/assets/plus-blue.svg" alt="Add" className="r-mr-2 r-mb-1" />
                <span>Upload another file</span>
            </div>
        </div>
    );
};

export const UploadDocBox = ({ handleClick, handleDrag, handleDrop, mainText }: any) => {
    return (
        <button
            className={styles.bankStmtBtn}
            onClick={handleClick}
            onDrop={handleDrop}
            onDragOver={handleDrag}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
        >
            <span>
                <img
                    src="/assets/cloud_upload.svg"
                    className={`r-mr-1 ${styles.uploadImg}`}
                    alt=""
                />
                <span className="fs-12 text-blue4">{mainText}</span>
            </span>
            <span className="fs-10 text-grey9">
                <i>Click or drag here to upload files</i>
            </span>
        </button>
    );
};
